// Console light / dark / system, like the FlowConnect dashboard (dark by default). Stored per browser.
import { computed, ref, watch } from 'vue'

export type ThemePref = 'dark' | 'light' | 'system'
const KEY = 'ff-console-theme'

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'system' ? v : 'dark'
  } catch {
    return 'dark'
  }
}

const media = typeof matchMedia === 'function' ? matchMedia('(prefers-color-scheme: dark)') : null
export const pref = ref<ThemePref>(read())
const systemDark = ref(media?.matches ?? true)
media?.addEventListener('change', (e) => (systemDark.value = e.matches))
export const resolvedTheme = computed(() => (pref.value === 'system' ? (systemDark.value ? 'dark' : 'light') : pref.value))

watch(
  resolvedTheme,
  (t) => document.documentElement.classList.toggle('dark', t === 'dark'),
  { immediate: true },
)
watch(pref, (v) => {
  try {
    localStorage.setItem(KEY, v)
  } catch {
    // Private mode: the choice lasts for this page only.
  }
})
